{
  "pending": "в очікуванні"
}
